import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_PageLoader } from 'redux/modules/pageloader/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_Bookings } from 'redux/modules/bookings/Actions'
import { TCurrentBooking } from 'utils/types/TCurrentBooking'
import { TStoreTemplate } from 'redux/config/root-types'

const { get } = RequestMethods()

export interface ISagaPage_BookingDetails {
  id: string
}

export default function* SagaPage_BookingDetails(action: PayloadAction<ISagaPage_BookingDetails>) {
  const { id } = action.payload
  try {
    yield put(Actions_PageLoader.store.showLoader())

    //------------------------- Getting and saving station ---------------------------//
    const res: TStoreTemplate<TCurrentBooking> = yield call(
      async () => await get<TCurrentBooking>(`/bookings/${id}/extended`),
    )
    yield put(Actions_Bookings.store.setCurrentBooking(res.data))

    yield put(Actions_PageLoader.store.hideLoader())
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  }
}
